
export interface IUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  gender?: 'male' | 'female' | 'other';
  role: string;
  isActive: boolean;
  accountStatus?: "active" | "suspended" | "banned";
  suspendedUntil?: Date;
  suspendedServices?: string[];
  reason?: string;
  age?: number;
  isPartner: boolean;
  subscriptionType: string
  isSubscriptionActive: boolean;
  phoneVerified?: boolean;
  emailVerified?: boolean;
  registrationCompleted: boolean;
  totalLobbiesJoined?: number;
  xApplicationType:string;
  totalMatches?: number;
  phoneNumber: string;
  profilePhotos:ProfilePhoto[];
  createdAt?: Date;
  updatedAt?: Date | string;
  selected: boolean;
  lastLoginAt?: Date | string; 
  location?: {
    city: string;
    state: string;
    country: string;
  };
  voiceRecordUrl?: string;
  voiceBio?: string;
  deletedAt?: Date | string;
  phoneNumberCarrierName?: string;
  phoneNumberType?: string;
  auth_provider?: string;
}
export interface ProfilePhoto {
  photoId: string;
  fileName: string;
  s3Key: string;
  isPrimary: boolean;
  signedUrl: string;
}
export interface IUsersApiData {
  users: IUser[];
  totalCount: number;
  hasMore: boolean;
  currentPage: number;
}

export type IUsersApiResponse = IUsersApiData;


export interface IUserStatusUpdateRes{
  userId: string
  isActive: boolean
  message: string
  updatedAt: string
}

export interface IUserStatusUpdateReq{
  userId: string
  isActive: boolean
}

export interface IUserRoleUpdateRes {
  userIds: string[];
  role: string;
  message: string;
  updatedAt: string;
}

export interface IUserRoleUpdateReq {
  userIds: string[];
  role: 'user' | 'admin' | 'super_admin';
}

export interface IWaitlistUserReq {
  firstName: string
  lastName: string
  phone?: string
  email: string
  preferredContactMethod?: number;
  leadSource?: number
  isOptionalFieldEnabled: boolean
  specificQuestionsOrRequests?: string | null;
  createdAt?: string;
  selected?: boolean;
  id?: string;
  fullName?: string;
  deletedAt?: Date | string;
  isActive?: boolean;
}

export enum WaitlistContactMethod {
  Email = 1,
  Text = 2,
}

export enum WaitlistLeadSourceEnum {
  SocialMedia = 1,
  WordOfMouth = 2,
  Website = 3,
  EmailNewsLetter = 4,
  Events = 5,
  SearchEngines = 6,
  Other = 7,
}

export interface IUserDetailsResponse {
  user: IUserDetails;
  activities: IUserActivity[];
}

export interface IUserDetails {
  id: string;
  name: string;
  email: string;
  image: string | null;
  status: string;
  joinDate: string;
  lastActive: string;
  partiesAttended: number;
  totalPoints: number;
}

export interface IUserActivity {
  type: string;
  title: string;
  timestamp: string;
  rawTime: string;
}

export interface IBanUserData {
  success: boolean;
  message: string;
}